import http from '../../../../libs/http'
import config from '../../../../config/shops'
export default (id, payload = {}) => http.post(`${config.api}/requests/${id}/details`, payload)
